// Shared utilities for TV display — adapted from guidebook WeatherCard / HighlightsStrip

export function weatherEmoji(code: number | null, isDay: boolean | null): string {
  if (code == null) return ""
  if (code === 0 || code === 1) return isDay ? "\u2600\uFE0F" : "\uD83C\uDF19"
  if (code === 2) return "\u26C5"
  if (code === 3) return "\u2601\uFE0F"
  if (code === 45 || code === 48) return "\uD83C\uDF2B\uFE0F"
  if (code >= 51 && code <= 57) return "\uD83C\uDF27\uFE0F"
  if (code >= 61 && code <= 67) return "\uD83C\uDF27\uFE0F"
  if (code >= 71 && code <= 77) return "\u2744\uFE0F"
  if (code >= 80 && code <= 82) return "\uD83C\uDF26\uFE0F"
  if (code >= 85 && code <= 86) return "\uD83C\uDF28\uFE0F"
  if (code >= 95) return "\u26C8\uFE0F"
  return "\uD83C\uDF24\uFE0F"
}

export function formatClockLocal(iso: string | null, tz: string | null): string {
  if (!iso) return ""
  try {
    const d = new Date(iso)
    return d.toLocaleTimeString("en-GB", {
      timeZone: tz || undefined,
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
    })
  } catch {
    return ""
  }
}

export function windDirectionLabel(deg: number | null): string {
  if (deg == null) return ""
  const dirs = ["N", "NE", "E", "SE", "S", "SW", "W", "NW"]
  return dirs[Math.round(deg / 45) % 8]
}

/** Format a checkout ISO date as day of week: "Sunday", "Monday", etc. */
export function formatCheckoutDay(isoDate: string | null | undefined): string | null {
  if (!isoDate) return null
  try {
    const d = new Date(isoDate + "T12:00:00")
    if (isNaN(d.getTime())) return null
    return d.toLocaleDateString("en-US", { weekday: "long" })
  } catch {
    return null
  }
}

/** Build a compact one-line weather string for the hero slide */
export function buildWeatherOneliner(
  weather: { temperature_c: number | null; weather_label: string | null; wind_speed_ms: number | null; wind_direction_deg: number | null } | null,
): string | null {
  if (!weather || weather.temperature_c == null) return null
  const temp = Math.round(weather.temperature_c)
  const label = weather.weather_label || ""
  const windDir = windDirectionLabel(weather.wind_direction_deg)
  const windSpeed = weather.wind_speed_ms != null ? Math.round(weather.wind_speed_ms) : null
  let line = `${temp}\u00B0 \u00B7 ${label}`
  if (windSpeed != null && windDir) {
    line += ` \u00B7 Wind ${windSpeed} m/s ${windDir}`
  }
  return line
}

/** Resolve area name from property data */
export function resolveAreaName(property: { region_description?: string }, places: Array<{ area?: string }>): string {
  if (property.region_description) return property.region_description
  const firstArea = places.find((p) => p.area)?.area
  return firstArea || "the area"
}

/** Truncate text to max chars, breaking at word boundary */
export function truncate(text: string | null | undefined, max: number): string | null {
  if (!text) return null
  if (text.length <= max) return text
  const cut = text.slice(0, max)
  const lastSpace = cut.lastIndexOf(" ")
  return (lastSpace > max * 0.6 ? cut.slice(0, lastSpace) : cut) + "\u2026"
}
